/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetRecruitmentQueryParams, GetRecruitment200, GetRecruitment400, GetRecruitmentQueryResponse } from '../entities/GetRecruitment'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetAllRecruitmentResponseSchema } from './v1/getAllRecruitmentResponseSchema'
import { z } from 'zod'

export const getRecruitmentQueryParamsSchema = z.object({
  city_id: z.string().optional(),
  from_date: z.string().optional(),
  limit: z.number().int().min(1),
  offset: z.number().int().min(0),
  phone: z.string().optional(),
  recruiter_id: z.string().optional(),
  state: z.array(z.enum(['idle', 'checkin', 'accept', 'decline', 'unknown'])).optional(),
  to_date: z.string().optional(),
}) as unknown as ToZod<GetRecruitmentQueryParams>

/**
 * @description OK
 */
export const getRecruitment200Schema = z.lazy(() => v1GetAllRecruitmentResponseSchema) as unknown as ToZod<GetRecruitment200>

/**
 * @description Bad Request
 */
export const getRecruitment400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetRecruitment400>

export const getRecruitmentQueryResponseSchema = z.lazy(() => getRecruitment200Schema) as unknown as ToZod<GetRecruitmentQueryResponse>